// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2mk8c","range":"MonthRangeSwitch_range__2j_bn","disabled":"MonthRangeSwitch_disabled__CXkIP"};